import { useContext } from 'react';
import { WorkbookDataLoadingContext } from '../Context';

export const useWorkbookDataLoading = () => {
  const loading = useContext(WorkbookDataLoadingContext);

  return loading;
};

export default useWorkbookDataLoading;